import { Link } from 'react-router-dom';

export function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20flowing%20organic%20shapes%2C%20soft%20golden%20and%20cream%20tones%2C%20paper-like%20texture%2C%20minimalist%20artistic%20composition%2C%20gentle%20curves%2C%20elegant%20atmosphere%2C%20high%20resolution%2C%20no%20text%2C%20abstract%20expression&width=1800&height=900&seq=hero-bg-yiqicao&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 text-center">
        <div className="inline-flex items-center gap-2 bg-background-50/15 backdrop-blur-sm border border-background-50/20 rounded-full px-4 py-2 mb-6">
          <span className="w-2 h-2 bg-green-400 rounded-full animate-pulse"></span>
          <span className="text-sm text-background-50/90">一起草官网入口 — 官方直达通道</span>
        </div>

        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight mb-4 max-w-3xl mx-auto">
          AI智能创作平台
          <span className="block text-primary-300 mt-1">让创作更简单，让表达更有力</span>
        </h1>

        <p className="text-sm md:text-base text-background-50/70 max-w-xl mx-auto mb-8 leading-relaxed">
          一起草官网入口为您提供AI写作、文章润色、大纲生成等一站式内容创作解决方案。
          无论您是自媒体人、企业营销还是学术研究者，这里都能满足您的创作需求。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="/register"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 font-medium rounded-lg hover:bg-primary-600 transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
          >
            <i className="ri-user-add-line"></i>
            免费注册体验
          </a>
          <Link
            to="/category/feature-guide"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-background-50/10 backdrop-blur-sm border border-background-50/25 text-background-50 font-medium rounded-lg hover:bg-background-50/20 transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
          >
            <i className="ri-guide-line"></i>
            了解功能
          </Link>
        </div>

        <div className="mt-10 flex items-center justify-center gap-6 text-background-50/50 text-xs">
          <span className="flex items-center gap-1.5">
            <i className="ri-shield-check-line"></i> 安全可靠
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-flashlight-line"></i> 极速生成
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-copyright-line"></i> 版权归您
          </span>
        </div>
      </div>
    </section>
  );
}